module.exports = {
	"commitCount": 1,
	"commitMembers": [
		{
			"count": 1,
			"authorName": "Bobjoy"
		}
	],
	"commitUniqueCount": 1
};


//////////////////
// WEBPACK FOOTER
// ./zh-CN/components/wechat-emotion_git_metas.json
// module id = 2549
// module chunks = 20